import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import findResult, { isChecked } from '@/utils/resultsHelper';
import { configurationCodes } from '@/configurations/constants';
import { omniSearchLinks } from '../typeAheadSearch';

const makeSelectOmniSearch = (category) => createSelector(
  ({ auth }) => auth,
  ({ cohorts }) => cohorts,
  ({ collections }) => collections,
  ({ configurations: c }) => c,
  ({ datasets }) => datasets,
  ({ requests }) => requests,
  ({ search }) => search,
  ({ userGroups }) => userGroups,
  ({ vocabularies: v }) => v,
  (auth, cohorts, collections, configurationsState, datasets, requests, search, userGroups, vocabulariesState) => {
    const searchItem = findResult(search.searches, category, null);
    const configuration = findResult(configurationsState.configurations, 'all', configurationCodes.WORKFLOW_TASK_LIST)
      || { value: { value: false } };

    return {
      currentUser: auth.currentUser,
      query: searchItem.query,
      results: searchItem.results,
      searchStatus: searchItem.searchStatus,
      userPermissions: auth.role.permissions,
      newCohortCode: cohorts.newCohortCode,
      newDatasetCode: datasets.newDatasetCode,
      newCollectionCode: collections.newCollectionCode,
      newRequestCode: requests.newRequestCode,
      newUserGroupCode: userGroups.newUserGroupCode,
      taskLinkEnabled: isChecked(configuration.value.value),
      ...omniSearchLinks(searchItem, vocabulariesState.vocabularies),
    };
  },
);

const useOmniSearch = ({ category }) => {
  const selector = useMemo(() => makeSelectOmniSearch(category), [category]);
  return useSelector(selector);
};

export default {
  useOmniSearch,
};
